import { ExportReq, HttpService, Records } from "@/core";
import { ExportResp } from "@/core/interface";
import {
  OrderPageReq,
  OrderPageResp,
  OrderSimpleRecord,
  OrderDetailResp,
  OrderReq,
  MaterialRecord,
} from "./order.interface";
import { ContractService } from "@/views/purchase/contract/contract.service";
import { EmployeeService } from "@/views/organization/employee/employee.service";
import moment from "moment";
import { generateUuid } from "@/utils";
import NP from "number-precision";
export class OrderService {
  static usePageApi() {
    const api = (params: OrderPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/purchase_order/page",
        params,
      });
    return HttpService.usePagination<OrderPageResp>(api);
  }

  static useSimpleListApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/purchase_order/simple/list",
        params,
      });
    return HttpService.useRequest<Records<OrderSimpleRecord>>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/purchase_order/${id}`,
      });
    return HttpService.useRequest<OrderDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: OrderReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_order",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: OrderReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/purchase_order/${id}`,
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/purchase_order/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_order/export",
        data: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static useMaterialImportApi() {
    const api = (url: string, id: string) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_order/import/detail",
        data: { url, id },
      });
    return HttpService.useRequest<Records<MaterialRecord>>(api);
  }

  static useMaterialExportApi() {
    const api = (id: string, titleParamReqs: any) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_order/export/new/detail",
        // data: { ids: [id] },
        data: { ids: [id], titleParamReqs: titleParamReqs },
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  static async backfillByContractId(contractId) {
    const result = {
      projectId: "",
      partyBCooperationCompanyId: "",
      partyBCooperationCompanyName: "",
      invoiceType: "",
      invoiceTypeName: "",
      taxRate: "",
      taxRateName: "",
      supplierContacts: "",
      supplierMobile: "",
      purchaseContractType: "",
      name: "",
    };
    if (!contractId) {
      return result;
    }
    const { run } = ContractService.useDetailApi();
    const res = await run(contractId);
    let contractList: any = [];
    let type: number = 0;
    if (res.respCode === "0000" && res.data) {
      const { purchaseContractAResp, purchaseContractDetailAResps } = res.data;
      result.projectId = purchaseContractAResp?.projectId as string;
      result.partyBCooperationCompanyId = purchaseContractAResp?.partyBCooperationCompanyId as string;
      result.partyBCooperationCompanyName = purchaseContractAResp?.partyBCooperationCompanyName;
      result.invoiceType = purchaseContractAResp?.invoiceType as string;
      result.invoiceTypeName = purchaseContractAResp?.invoiceTypeName as string;
      result.taxRate = purchaseContractAResp?.taxRate as string;
      result.supplierContacts = purchaseContractAResp?.supplierContacts as string;
      result.supplierMobile = purchaseContractAResp?.supplierMobile as string;
      result.purchaseContractType = purchaseContractAResp?.purchaseContractType as string;
      result.name = `${purchaseContractAResp?.projectName}采购订单${moment().format(
        "YYYYMMDDHHmmss"
      )}`;
      type = purchaseContractAResp.type;
      // if (purchaseContractAResp.type == 1) {
        contractList = (purchaseContractDetailAResps || []).map((v: any) => {
          v.currentOrderCount = v.count;
          v.purchaseContractDetailId = v.id;
          v.uuid = generateUuid();
          v.taxAmount = NP.times(
            v.currentOrderCount || 0,
            NP.times(v.price || 0, NP.divide(purchaseContractAResp.taxRate || 0, 100).toFixed(4))
          );
          return v;
        });
      // }
    }
    return {
      purchaseOrderInfoReq: result,
      purchaseOrderDetailReqs: contractList,
      type,
    };
  }

  static async backfillByUserId(userId) {
    const result = {
      receiveTenantUserMobile: "",
    };
    if (!userId) {
      return result;
    }
    const { run } = EmployeeService.useDetailApi();
    const res = await run(userId);
    if (res.respCode === "0000" && res.data) {
      const { mobile } = res.data;
      result.receiveTenantUserMobile = mobile;
    }
    return { purchaseOrderInfoReq: result };
  }

  static validDetail(list: MaterialRecord[] = []) {
    if (list.length === 0) {
      return false;
    }
    let valid = true;
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if (!item.currentOrderCount) {
        valid = false;
        break;
      }
    }
    return valid;
  }
  static orderAddNew() {
    const api = (data: OrderReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_order/add_new",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }
}
